var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insert_chart_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Light Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5H19V19H5V5ZM7 17H9V10H7V17ZM13 17H11V7H13V17ZM15 17H17V13H15V17Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19ZM19 5H5V19H19V5Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    d: "M7 10H9V17H7V10Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    d: "M11 7H13V17H11V7Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_5",
    d: "M15 13H17V17H15V13Z",
    fill: "white",
    fillOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.12eadd336df3f0fcd12aed1075506629.svg";
export { ForwardRef as ReactComponent };